import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpDeleteDocument} from '@/services/address.http'
import {errorHandler} from '@/utilities/helpers'
import {MUTATION_KEYS} from '@/queryClient'

export const useDeleteDocument = (options?: UseMutationOptions<unknown, unknown, string>) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.DELETE_DOCUMENT],
        mutationFn: (documentId: string) =>
            httpDeleteDocument({
                urlParams: {documentId}
            }),
        onError: errorHandler,
        onSuccess: (data, variables, context) => {
            options?.onSuccess?.(data, variables, context)
        }
    })
}
